import { HttpErrorResponse } from '@angular/common/http';

import { ErrorStatus } from './error-status.model';

export interface ErrorInterface {
  message: string;
  errorResponse?: HttpErrorResponse;
  exception?: string;
  source: string;
  status?: ErrorStatus;
  timestamp?: Date | number;
}

export class Error implements ErrorInterface {
  public message: string;
  public errorResponse?: HttpErrorResponse;
  public exception?: string;
  public source: string;
  public status?: ErrorStatus;
  public timestamp?: Date | number;

  constructor({
      message,
      errorResponse = undefined,
      exception = undefined,
      source = undefined,
      status = ErrorStatus.Raised,
      timestamp = Date.now(),
    }: ErrorInterface) {
    this.message = message;
    this.errorResponse = errorResponse;
    this.exception = exception;
    this.source = source;
    this.status = status;
    this.timestamp = timestamp;
  }
}
